import { render, staticRenderFns } from "./Emendas.vue?vue&type=template&id=1f62627a"
import script from "./Emendas.vue?vue&type=script&lang=js"
export * from "./Emendas.vue?vue&type=script&lang=js"
import style0 from "./Emendas.vue?vue&type=style&index=0&id=1f62627a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports